<template>

  <!--红包活动弹窗(显示金额)-->
  <!--<div class="red-new-alert">-->
    <!--<div class="red-new-alert-con border-box">-->
      <!--<img class="red-new-logo" src="../assets/red-new-logo.png" alt="">-->
      <!--<p class="red-new-top tc">您获得了1个优惠红包<br>语音专辑 <span style="color: #c72727;">减免 {{ redEnvelNew.money }} 元</span></p>-->
      <!--<span class="red-new-line"></span>-->
      <!--<div class="red-new-mid">-->
        <!--<img src="../assets/red-new-text.png" alt="">-->
        <!--<div class="red-new-mid-num">{{ redEnvelNew.money }}<span>元</span></div>-->
        <!--<div class="red-new-mid-text">恭喜您获得优惠红包</div>-->
      <!--</div>-->
      <!--<div class="red-new-btn" @click="takeEnvelope(0)">立即领取</div>-->
      <!--<div class="red-new-bg red-new-bg1"></div>-->
      <!--<div class="red-new-bg red-new-bg2"></div>-->
      <!--<img @click="takeEnvelope(1)" class="red-new-close" src="../assets/red-envelopes-close.png" />-->
    <!--</div>-->
  <!--</div>-->

  <!--红包活动弹窗(不显示金额)-->
  <div class="red-new-alert">
    <div class="red-box border-box">
      <img class="red-bg" src="../assets/hb.jpg" alt=""  @click="takeEnvelope(0)">
      <img class="red-close" src="../assets/icon_04.png" @click="takeEnvelope(1)" />

      <div class="red-tit">—领取现金红包—</div>
      <!--<div class="red-text">听都江堰36个景点解说</div>-->
      <div class="red-text">{{redEnvelNew.name}}</div>
    </div>
  </div>

</template>

<script>

  import {getCouponReceive} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {},
        isSuccess: false, //是否提交
      }
    },
    created(){

    },
    props: ['redEnvelNew'],
    computed: {

    },
    methods: {

      //抢红包
      async takeEnvelope(type){
        this.userInfo = getStore("userInfo");

        if(this.isSuccess){
          return;
        }else {
          this.isSuccess = true;
          this.redEnvelNew.takeEnvelope = 1;

          let that = this;
          getCouponReceive(that.redEnvelNew.id,type,function(res){

            if(res.data.errcode == '00000'){

              setTimeout(function() {
                this.isSuccess = false;
                that.redEnvelNew.takeEnvelope = 0;
                that.$emit('close',{redEnvelopes: [], personEnvelopes: [], recommendPerson: "",redEnvelNew1: 1,type: type});
              }, 600)

            }
          })


        }
      }

    },
  }
</script>

<style scoped>

  /*新版红包*/
  .red-new-alert{position:fixed;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8);z-index: 99;}
  .red-new-alert-con{position:absolute;top:50%;left:50%;width: 85%;margin-left:-42.5%;padding:1.1rem .5rem .24rem;background: #fff;border-radius: .16rem;transform: translateY(-50%);}
  .red-new-logo{position: absolute;left:50%;top:-.04rem;width: 2.42rem;height: .94rem;margin-left: -1.21rem;}
  .red-new-top{font: .3rem/.54rem "Microsoft YaHei";color: #333;}
  .red-new-line{display: inline-block;width: 100%;height: 0;margin-top:.32rem;border-top: 1px dashed #e5e5e5;}
  /*.red-new-line{display: inline-block;width: 100%;height: 1px;margin-top:.32rem;background: url(../../assets/red-new-logo.png) repeat center;}*/
  .red-new-mid{position:relative;width: 100%;height: 3.59rem;margin-top: .42rem;}
  .red-new-mid img{display: block;width: 3.59rem;height: 100%;margin: 0 auto;}
  .red-new-mid-num{position: absolute;left: 50%;top: 1.73rem;font-size: .48rem;transform: translateX(-50%);color: #fff;}
  .red-new-mid-num span{margin-left:.04rem;font-size: .26rem;}
  .red-new-mid-text{position: absolute;left: 0;bottom:.04rem;width: 100%;text-align:center;font-size:.24rem;color: #fd4655;}
  .red-new-btn{width:2.79rem;height:.8rem;margin: 1.2rem auto 0;font:.28rem/.76rem "Microsoft YaHei";text-align: center;background: url(../assets/red-new-btnBg.png) no-repeat center;background-size: 100% 100%; }
  .red-new-bg{position: absolute;background: rgba(255,255,255,.5);border-radius: 0 0 .16rem .16rem;}
  .red-new-bg1{left:.24rem;right:.24rem;bottom:-.23rem;height: .23rem;}
  .red-new-bg2{left:.65rem;right:.65rem;bottom:-.43rem;height: .2rem;}
  .red-new-close{position:absolute;left:50%;bottom:-.55rem; z-index: 1; width:.40rem;height:.40rem;transform:translateX(-50%);}

  .red-box{position:absolute;top:50%;left:50%;width:74.5vw;transform:translate(-50%,-50%);}
  .red-bg{position:relative;width:100%;height:auto; border-radius: .2rem ; }
  .red-close{position:absolute; right: .13rem; top: .1rem; z-index: 1; padding: .05rem; width:.23rem;height:.23rem; }
  .red-tit{position:absolute; left: 0; top: 32%; width:100%;text-align: center; font: bold .41rem/.45rem "Microsoft YaHei";letter-spacing: .1rem; }
  .red-text{position:absolute; left: 0; top: 40.5%; width:100%;text-align: center; font: .3rem/.33rem "Microsoft YaHei";letter-spacing: .02rem; }


</style>



// WEBPACK FOOTER //
// src/components/AlertRedEnvelNew.vue